import { useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '@dreamtree-org/twreact-ui';

/**
 * Page title + breadcrumb trail + right-aligned actions.
 * A layout composition over twreact-ui's Breadcrumbs — no new primitives.
 *
 * trail: [{ label, to? }] — the last entry is the current page.
 */
export default function PageHeader({ title, subtitle, trail = [], actions = null }) {
  const nav = useNavigate();
  const items = trail.map((t, i) => ({
    id: `${i}-${t.label}`,
    label: t.label,
    onClick: t.to ? () => nav(t.to) : undefined,
  }));

  return (
    <div className="space-y-3">
      {items.length > 0 ? (
        <Breadcrumbs items={items} showHome onHomeClick={() => nav('/')} />
      ) : null}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h1 className="truncate text-xl font-bold text-[var(--app-text)] sm:text-2xl">{title}</h1>
          {subtitle ? <p className="mt-0.5 text-sm text-[var(--app-muted)]">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  );
}
